const leaflets = {
    "client": {
        "config": {
            "pdfPath": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/pdf/Volantino_Gennaio_Milano_Crespi_compressed_page-0001.pdf",
            "noIconAnimated": false,
            "ogImageMeta_mobile": "https://dev02.interattivo.net/media/settings/project/image_meta_mobile/Galbusera-WA.jpg",
            "serverPath": "galbusera.interattivo.net",
            "hover_color": "rgba(0,57,121,0.5)",
            "adsense": false,
            "hide_share_grocery_list": false,
            "hide_share_product": false,
            "hide_product_page": false,
            "hide_category_filter": false,
            "only_browsable": false,
            "hide_grocery_list": false,
            "hide_searchbar": false,
            "clientIcon": "https://dev02.interattivo.net/media/settings/project/client_icon/logo-galbusera.png",
            "client_code": null,
            "slug": "galbusera",
            "flyer_status": 1,
            "release_id": "118",
            "ga_active": false,
            "pager": "buttons",
            "sidebar": [
                "leaflet",
                "products",
                "pages",
                "pdf",
                "full_screen",
                "share"
            ],
            "send_grocery_list_to_market": false,
            "grocery_list_min_value": 0,
            "has_pages": true,
            "category_banner": null,
            "category_banner_mobile": null,
            "hide_plus_product": false,
            "hide_plus_product_price": false,
            "hide_listPages": false,
            "type": "leaflet",
            "format": "13",
            "no_link_to_site": false,
            "iconAnimation": "vertical",
            "largeIcon": false,
            "hide_logo": false,
            "small_logo": false,
            "show_one_page": false,
            "version": 15,
            "filterBrand": 0,
            "filterUnderprice": 0,
            "marker_product_in_list": true,
            "marker": "circle_black",
            "client_id": 124,
            "signboard_id": 151,
            "expirationDate": "2099-01-13T10:49:00+01:00",
            "primary_color": "#003979",
            "secondary_color": "#f2633c",
            "tertiary_color": "#faa343",
            "brandImage": null,
            "underPriceImage": null,
            "shareFlyerTitle": "Galbusera | Volantino Interattivo",
            "shareFlyerURL": "https://galbusera.interattivo.net",
            "shareProductSentence": "Sfoglia il Volantino Interattivo.",
            "ogTitleMeta": "Galbusera | Volantino Interattivo",
            "ogDescriptionMeta": "Dai uno sguardo al nostro nuovo volantino.",
            "ga_tracking_id": "UA-152069090-38",
            "ogImageMeta": "https://dev02.interattivo.net/media/settings/project/image_meta/Galbusera_Fb_1.png",
            "internal_banner_click": false,
            "external_banner_click": false,
            "href_banner": "",
            "product_banner": null
        },
        "leaflet": {
            "code": "159",
            "id_campaign": "",
            "name": "Galbusera",
            "index": {
                "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/pages/Indice-demo-Galbusera1_M3jJll7.png",
                "thumb_image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/pages/thumb_OVOdoqqVrI/pages/Indice-demo-Galbusera1_M3jJll7.png",
                "links": [
                    {
                        "id": 99,
                        "page": 2,
                        "blueprint": {
                            "top": 30.354958089334453,
                            "left": 50.85396308360478,
                            "width": 40.69598262757871,
                            "height": 15.26916622657667
                        },
                        "target": "_blank",
                        "title": "",
                        "color": "",
                        "url": "",
                        "type": "internal_link"
                    },
                    {
                        "id": 100,
                        "page": 1,
                        "blueprint": {
                            "top": 30.601516730693334,
                            "left": 7.528230184581977,
                            "width": 40.23507057546144,
                            "height": 15.165522603053534
                        },
                        "target": "_blank",
                        "title": "",
                        "color": "",
                        "url": "",
                        "type": "internal_link"
                    }
                ]
            },
            "categories": [
                {
                    "category_name": "Alimentari",
                    "subcategories": [
                        "Dispensa",
                        "Snack",
                        "Rossi"
                    ]
                },
                {
                    "category_name": "Igiene persona",
                    "subcategories": [
                        "Benessere e salute"
                    ]
                },
                {
                    "category_name": "Bevande",
                    "subcategories": [
                        "Bibite",
                        "Vini e spumanti"
                    ]
                }
            ],
            "pages": [
                {
                    "number": 1,
                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/worker/pages/page_1_G3496EX.jpg",
                    "thumb_image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/worker/pages/thumb_page_0.jpg",
                    "interactivities": [
                        {
                            "id": 508,
                            "ean_code": null,
                            "codice_interno_insegna": "cstm7299821630",
                            "field1": "Galbusera",
                            "field2": "belle buone fette spesse",
                            "field3": "200g",
                            "field4": "",
                            "descrizione_estesa": "                                                    ",
                            "description": "Galbusera belle buone fette spesse 200g",
                            "grammage": 0,
                            "offer_price": "2.99",
                            "type": "product",
                            "item_id": "508",
                            "calcolo_prezzo": 1,
                            "price": "2.19",
                            "price_label": "\u20ac 2,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": 1,
                            "max_purchasable_pieces": 1,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "category_id": "1985",
                            "subcategory_id": "1986",
                            "blueprint": {
                                "top": 22.50277815929778,
                                "left": 0.0,
                                "width": 39.176034017502204,
                                "height": 25.351645659438244
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/FETTE_SPESSE_Fichi_e_nocciole_200g_030919_bqGppvU.png",
                                    "cropped": false,
                                    "pk": 738
                                },
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/FETTE_SPESSE_Mirtilli_rossi_200g_030919_NQwmynP.png",
                                    "cropped": false,
                                    "pk": 739
                                },
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/FETTE_SPESSE_MUESLI_200g_140220_NAJiSTe.png",
                                    "cropped": false,
                                    "pk": 740
                                },
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/FETTE_SPESSE_Papavero_girasole_200g_030919_mnF5CYP.png",
                                    "cropped": false,
                                    "pk": 741
                                },
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/cropped_image_4pPwU75_Q7cabyb.png",
                                    "cropped": true,
                                    "pk": 722
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "active": true,
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "specs",
                                    "active": true,
                                    "title": "Valori nutrizionali",
                                    "data": {
                                        "specifiche": "ENERGIA 1704 kJ/ 407 kcal, GRASSI 12.5 g, di cui ACIDI GRASSI SATURI 3.8 g, CARBOIDRATI 64.5 g, di cui ZUCCHERI 3.5 g, POLIOLI 15.0 g, 0.6 g, FIBRE 10.0 g, PROTEINE 10.0 g, SALE 1.0 g.",
                                        "img": [
                                            "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/images/FETTE_SPESSE_Fichi_e_nocciole_200g_030919.png"
                                        ]
                                    }
                                },
                                {
                                    "type": "play",
                                    "active": true,
                                    "title": "",
                                    "data": {
                                        "video_type": "video_file",
                                        "open_modal": false,
                                        "link": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/video/Galbusera_BelleBuone.mp4"
                                    }
                                }
                            ],
                            "weight_unit_of_measure": "gr",
                            "strike_price": null,
                            "discount_rate": 0,
                            "prices": null,
                            "promo": null,
                            "stock": null,
                            "tdc": null,
                            "available_from": null,
                            "related": [],
                            "brand": null,
                            "brand_logo": null,
                            "line": null,
                            "line_logo": null
                        },
                        {
                            "id": 509,
                            "ean_code": null,
                            "codice_interno_insegna": "cstm9261680933",
                            "field1": "Tre marie",
                            "field2": "torta brunilde",
                            "field3": "450g",
                            "field4": "",
                            "descrizione_estesa": "                                                    ",
                            "description": "Tre marie torta brunilde 450g",
                            "grammage": 0,
                            "offer_price": "6.90",
                            "type": "product",
                            "item_id": "509",
                            "calcolo_prezzo": 1,
                            "price": "3.90",
                            "price_label": "\u20ac 3,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": 1,
                            "max_purchasable_pieces": 1,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "category_id": "1985",
                            "subcategory_id": "1986",
                            "blueprint": {
                                "top": 22.50277815929778,
                                "left": 39.176034017502204,
                                "width": 29.407327065619477,
                                "height": 25.351645659438244
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/Brunilde_UGwc4NU_h6EGuwi.jpg",
                                    "cropped": false,
                                    "pk": 743
                                },
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/cropped_image_jdGHSLf_1Gzot0h.png",
                                    "cropped": true,
                                    "pk": 723
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "active": true,
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "specs",
                                    "active": true,
                                    "title": "Ingredienti",
                                    "data": {
                                        "specifiche": "Zucchero, Farina di frumento, Burro 14,2%, Cacao 7,5%, Grasso vegetale, Acqua, Tuorlo d'uovo fresco, Latte intero in polvere, Destrosio, 'Nocciola Piemonte IGP' 1,8%, Uova fresche, Amido modificato, Cioccolato alle nocciole gianduia 0,6%, Cioccolato fondente extra 0,6%, Siero di latte in polvere, Emulsionanti: mono- e digliceridi degli acidi grassi, lecitina di girasole, Latte scremato in polvere, Lattosio, Amido di frumento, Agenti lievitanti: difosfato disodico, carbonato acido di sodio, Sale, Sciroppo di glucosio disidratato, Addensante: alginato di calcio, Acidificante: acido citrico, Conservante: sorbato di potassio, Aromi",
                                        "img": [
                                            "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/images/Brunilde.jpg"
                                        ]
                                    }
                                }
                            ],
                            "weight_unit_of_measure": "gr",
                            "strike_price": null,
                            "discount_rate": 0,
                            "prices": null,
                            "promo": null,
                            "stock": null,
                            "tdc": null,
                            "available_from": null,
                            "related": [],
                            "brand": null,
                            "brand_logo": null,
                            "line": null,
                            "line_logo": null
                        },
                        {
                            "id": 510,
                            "ean_code": null,
                            "codice_interno_insegna": "cstm1880745670",
                            "field1": "Galbusera",
                            "field2": "riso su riso",
                            "field3": "mini gallette",
                            "field4": "70g",
                            "descrizione_estesa": "                                                    ",
                            "description": "Galbusera riso su riso mini gallette 70g",
                            "grammage": 0,
                            "offer_price": "1.65",
                            "type": "product",
                            "item_id": "510",
                            "calcolo_prezzo": 1,
                            "price": "1.16",
                            "price_label": "\u20ac 1,16",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": 1,
                            "max_purchasable_pieces": 1,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack",
                            "category_id": "1985",
                            "subcategory_id": "1990",
                            "blueprint": {
                                "top": 22.50277815929778,
                                "left": 68.58336108312169,
                                "width": 31.41663891687831,
                                "height": 25.351645659438244
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/Gallette_RSR_bWEE3Ok.jpg",
                                    "cropped": false,
                                    "pk": 744
                                },
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/cropped_image_bs1JB9V_FzIxS2e.png",
                                    "cropped": true,
                                    "pk": 724
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "active": true,
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "specs",
                                    "active": true,
                                    "title": "Ingredienti",
                                    "data": {
                                        "specifiche": "Farina di riso 40%, Riso e riso integrale 20%, Grano saraceno 20%, Mais, Olio di mais, Sale, Curcuma 0,59%",
                                        "img": [
                                            "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/images/Gallette_RSR.jpg"
                                        ]
                                    }
                                }
                            ],
                            "weight_unit_of_measure": "gr",
                            "strike_price": null,
                            "discount_rate": 0,
                            "prices": null,
                            "promo": null,
                            "stock": null,
                            "tdc": null,
                            "available_from": null,
                            "related": [],
                            "brand": null,
                            "brand_logo": null,
                            "line": null,
                            "line_logo": null
                        },
                        {
                            "id": 511,
                            "ean_code": null,
                            "codice_interno_insegna": "cstm9136347066",
                            "field1": "Galbusera",
                            "field2": "Zalet",
                            "field3": "500g",
                            "field4": "Il biscotto che racchiude tutta la tradizione della famiglia Galbusera",
                            "descrizione_estesa": "",
                            "description": "Galbusera Zalet 500g Il biscotto che racchiude tutta la tradizione della famiglia Galbusera",
                            "grammage": 0,
                            "offer_price": null,
                            "type": "product",
                            "item_id": "511",
                            "calcolo_prezzo": 1,
                            "price": "1.19",
                            "price_label": "\u20ac 1,19",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": 1,
                            "max_purchasable_pieces": 1,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "category_id": "1985",
                            "subcategory_id": "1986",
                            "blueprint": {
                                "top": 47.7020198513041,
                                "left": 0.0,
                                "width": 100.0,
                                "height": 22.854420008277895
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/CLASSICI_Zalet_500g_030919_qKBPsDd.png",
                                    "cropped": false,
                                    "pk": 745
                                },
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/cropped_image_WrupVsE_MQ9fuGX.png",
                                    "cropped": true,
                                    "pk": 725
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "active": true,
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "active": true,
                                    "title": "",
                                    "data": {
                                        "titolo": "Descrizione",
                                        "testo": "Il biscotto che racchiude tutta la tradizione della famiglia Galbusera, ideato in un retrobottega e preparato con malto e miele millefiori italiano.",
                                        "img": [
                                            "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/images/CLASSICI_Zalet_500g_030919.png"
                                        ]
                                    }
                                }
                            ],
                            "weight_unit_of_measure": "gr",
                            "strike_price": null,
                            "discount_rate": 0,
                            "prices": null,
                            "promo": null,
                            "stock": null,
                            "tdc": null,
                            "available_from": null,
                            "related": [],
                            "brand": null,
                            "brand_logo": null,
                            "line": null,
                            "line_logo": null
                        },
                        {
                            "id": 512,
                            "ean_code": null,
                            "codice_interno_insegna": "cstm8667960032",
                            "field1": "Mascherine ffp2",
                            "field2": "",
                            "field3": "confezione da 10 pezzi",
                            "field4": "",
                            "descrizione_estesa": "                                                    ",
                            "description": "Mascherine ffp2 confezione da 10 pezzi",
                            "grammage": 0,
                            "offer_price": null,
                            "type": "product",
                            "item_id": "512",
                            "calcolo_prezzo": 1,
                            "price": "4.90",
                            "price_label": "\u20ac 4,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": 1,
                            "max_purchasable_pieces": 1,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene persona",
                            "subcategory": "Benessere e salute",
                            "category_id": "1996",
                            "subcategory_id": "1997",
                            "blueprint": {
                                "top": 70.55643985958201,
                                "left": 0.0,
                                "width": 34.30774270856338,
                                "height": 25.841405885415373
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/zz0002336_mascherine-filtranti-ffp2-confezione-10-pz_copia_MEXeRqQ.jpg",
                                    "cropped": false,
                                    "pk": 746
                                },
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/cropped_image_Wc3C0jH_mOboB4v.png",
                                    "cropped": true,
                                    "pk": 726
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "active": true,
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "active": true,
                                    "title": "",
                                    "data": {
                                        "titolo": "Descrizione",
                                        "testo": "Mascherina FFP2 - la mascherina protettiva FFP2 si compone di un corpo filtrante formato da quattro strati di tessuto-non-tessuto in polipropilene ed offre una efficace protezione delle vie respiratorie da particelle solide e/o liquide non volatili come polveri, fumi e nebbie. Le maschere Rexpiria monouso sono 100% sicure, realizzate con materiali di alta qualit\u00e0.",
                                        "img": [
                                            "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/images/zz0002336_mascherine-filtranti-ffp2-confezione-10-pz_copia.jpg"
                                        ]
                                    }
                                }
                            ],
                            "weight_unit_of_measure": "gr",
                            "strike_price": null,
                            "discount_rate": 0,
                            "prices": null,
                            "promo": null,
                            "stock": null,
                            "tdc": null,
                            "available_from": null,
                            "related": [],
                            "brand": null,
                            "brand_logo": null,
                            "line": null,
                            "line_logo": null
                        },
                        {
                            "id": 513,
                            "ean_code": null,
                            "codice_interno_insegna": "cstm0203764724",
                            "field1": "Mascherine ffp2",
                            "field2": "",
                            "field3": "confezione da 25 pezzi",
                            "field4": "",
                            "descrizione_estesa": "                                                    ",
                            "description": "Mascherine ffp2 confezione da 25 pezzi",
                            "grammage": 0,
                            "offer_price": null,
                            "type": "product",
                            "item_id": "513",
                            "calcolo_prezzo": 1,
                            "price": "9.90",
                            "price_label": "\u20ac 9,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": 1,
                            "max_purchasable_pieces": 1,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene persona",
                            "subcategory": "Benessere e salute",
                            "category_id": "1996",
                            "subcategory_id": "1997",
                            "blueprint": {
                                "top": 70.55643985958201,
                                "left": 34.30774270856338,
                                "width": 34.59684553921433,
                                "height": 25.841405885415373
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/zzWhatsApp_Image_2022-01-04_at_16.05.54_copia_bianca_8OLn2Hl.png",
                                    "cropped": false,
                                    "pk": 747
                                },
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/zzWhatsApp_Image_2022-01-04_at_16.05.54_copia_G0XfqA9.png",
                                    "cropped": false,
                                    "pk": 748
                                },
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/cropped_image_tZC9eR7_wova8Fs.png",
                                    "cropped": true,
                                    "pk": 727
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "active": true,
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "weight_unit_of_measure": "gr",
                            "strike_price": null,
                            "discount_rate": 0,
                            "prices": null,
                            "promo": null,
                            "stock": null,
                            "tdc": null,
                            "available_from": null,
                            "related": [],
                            "brand": null,
                            "brand_logo": null,
                            "line": null,
                            "line_logo": null
                        },
                        {
                            "id": 514,
                            "ean_code": null,
                            "codice_interno_insegna": "cstm5885060602",
                            "field1": "Test rapidi antigenici",
                            "field2": "covid-19",
                            "field3": "per auto diagnosi",
                            "field4": "Acquisto massimo giornaliero: 3 pezzi",
                            "descrizione_estesa": "                                                    ",
                            "description": "Test rapidi antigenici covid-19 per auto diagnosi Acquisto massimo giornaliero: 3 pezzi",
                            "grammage": 0,
                            "offer_price": null,
                            "type": "product",
                            "item_id": "514",
                            "calcolo_prezzo": 1,
                            "price": "4.90",
                            "price_label": "\u20ac 4,90",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": 1,
                            "max_purchasable_pieces": 1,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Igiene persona",
                            "subcategory": "Benessere e salute",
                            "category_id": "1996",
                            "subcategory_id": "1997",
                            "blueprint": {
                                "top": 70.55643985958201,
                                "left": 68.90458824777772,
                                "width": 31.09541175222228,
                                "height": 25.841405885415373
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/tamponi_lmoAtuX.png",
                                    "cropped": false,
                                    "pk": 749
                                },
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/zzhightop-sars-cov-2-test-rapido-antigenico-covid-19-fai-da-te-1-pez_7AMMnKU.jpg",
                                    "cropped": false,
                                    "pk": 761
                                },
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/cropped_image_gNzP5Wc_Q3cgehK.png",
                                    "cropped": true,
                                    "pk": 728
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "active": true,
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "weight_unit_of_measure": "gr",
                            "strike_price": null,
                            "discount_rate": 0,
                            "prices": null,
                            "promo": null,
                            "stock": null,
                            "tdc": null,
                            "available_from": null,
                            "related": [],
                            "brand": null,
                            "brand_logo": null,
                            "line": null,
                            "line_logo": null
                        },
                        {
                            "id": 528,
                            "ean_code": null,
                            "codice_interno_insegna": "cstm8140716514",
                            "field1": "",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "descrizione_estesa": null,
                            "description": "",
                            "grammage": 0,
                            "offer_price": null,
                            "type": "external_link",
                            "item_id": "528",
                            "calcolo_prezzo": 1,
                            "price": "0.00",
                            "price_label": "None",
                            "equivalence": null,
                            "quantity_step": null,
                            "grocery_label": null,
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": 1,
                            "max_purchasable_pieces": 1,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": null,
                            "subcategory": null,
                            "category_id": null,
                            "subcategory_id": null,
                            "blueprint": {
                                "top": 9.562630006734695,
                                "left": 17.1715338070064,
                                "width": 65.51717913192911,
                                "height": 9.00619205238176
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/cropped_image_Hi1vdmp_iTtHJta.png",
                                    "cropped": true,
                                    "pk": 766
                                }
                            ],
                            "markers": [
                                {
                                    "type": "external_link",
                                    "active": true,
                                    "title": null,
                                    "data": {
                                        "link_type": "url",
                                        "link": "https://www.google.it/maps/place/Via+Gaetano+Crespi,+9,+20134+Milano+MI/@45.4796646,9.2419079,17z/data=!3m1!4b1!4m5!3m4!1s0x4786c65baaa7bb75:0xe5428e2c944cf3dc!8m2!3d45.4796609!4d9.2440966",
                                        "show_icon": true,
                                        "tooltip": "",
                                        "title": null,
                                        "color": "#000000"
                                    }
                                }
                            ],
                            "weight_unit_of_measure": null,
                            "strike_price": null,
                            "discount_rate": 0,
                            "prices": null,
                            "promo": null,
                            "stock": null,
                            "tdc": null,
                            "available_from": null,
                            "related": [],
                            "brand": null,
                            "brand_logo": null,
                            "line": null,
                            "line_logo": null
                        }
                    ]
                },
                {
                    "number": 2,
                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/worker/pages/page_2_j0OqeoG.jpg",
                    "thumb_image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/worker/pages/thumb_page_1.jpg",
                    "interactivities": [
                        {
                            "id": 515,
                            "ean_code": null,
                            "codice_interno_insegna": "cstm5733964799",
                            "field1": "Baratti & milano",
                            "field2": "crema alle nocciole",
                            "field3": "200g",
                            "field4": "",
                            "descrizione_estesa": "                                                    ",
                            "description": "Baratti & milano crema alle nocciole 200g",
                            "grammage": 0,
                            "offer_price": "6.50",
                            "type": "product",
                            "item_id": "515",
                            "calcolo_prezzo": 1,
                            "price": "2.99",
                            "price_label": "\u20ac 2,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": 1,
                            "max_purchasable_pieces": 1,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "category_id": "1985",
                            "subcategory_id": "1986",
                            "blueprint": {
                                "top": 22.995720864664058,
                                "left": 0.0,
                                "width": 36.71699766556703,
                                "height": 23.003652927695093
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/cremagianduia_0imoMLs.png",
                                    "cropped": false,
                                    "pk": 750
                                },
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/cropped_image_TuCKI3M_tNL5V2n.png",
                                    "cropped": true,
                                    "pk": 729
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "active": true,
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "weight_unit_of_measure": "gr",
                            "strike_price": null,
                            "discount_rate": 0,
                            "prices": null,
                            "promo": null,
                            "stock": null,
                            "tdc": null,
                            "available_from": null,
                            "related": [],
                            "brand": null,
                            "brand_logo": null,
                            "line": null,
                            "line_logo": null
                        },
                        {
                            "id": 516,
                            "ean_code": null,
                            "codice_interno_insegna": "cstm8184499524",
                            "field1": "Novi",
                            "field2": "tavolette nero",
                            "field3": "nero extra 70%/ nero nero 75%/",
                            "field4": "ecuador 75g",
                            "descrizione_estesa": "                                                    ",
                            "description": "Novi tavolette nero nero extra 70%/ nero nero 75%/ ecuador 75g",
                            "grammage": 0,
                            "offer_price": "2.10",
                            "type": "product",
                            "item_id": "516",
                            "calcolo_prezzo": 1,
                            "price": "1.20",
                            "price_label": "\u20ac 1,20",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "nero extra 70%",
                                "nero nero 75%",
                                "ecuador"
                            ],
                            "price_for_kg": null,
                            "available_pieces": 1,
                            "max_purchasable_pieces": 1,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack",
                            "category_id": "1985",
                            "subcategory_id": "1990",
                            "blueprint": {
                                "top": 22.995720864664058,
                                "left": 36.71699766556703,
                                "width": 30.260195243484983,
                                "height": 23.003652927695093
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/Tavoletta_novi_nero_nero_70_01_3_1lJY4vk.png",
                                    "cropped": false,
                                    "pk": 751
                                },
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/Tavoletta_novi_nero_nero_75_3_Puepsvz.png",
                                    "cropped": false,
                                    "pk": 752
                                },
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/cropped_image_wtY4rwP_LDyNKTw.png",
                                    "cropped": true,
                                    "pk": 730
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "active": true,
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "weight_unit_of_measure": "gr",
                            "strike_price": null,
                            "discount_rate": 0,
                            "prices": null,
                            "promo": null,
                            "stock": null,
                            "tdc": null,
                            "available_from": null,
                            "related": [],
                            "brand": null,
                            "brand_logo": null,
                            "line": null,
                            "line_logo": null
                        },
                        {
                            "id": 517,
                            "ean_code": null,
                            "codice_interno_insegna": "cstm2789044896",
                            "field1": "Lindt",
                            "field2": "Scatola lindor latte",
                            "field3": "250g",
                            "field4": "",
                            "descrizione_estesa": "                                                    ",
                            "description": "Lindt Scatola lindor latte 250g",
                            "grammage": 0,
                            "offer_price": "11.00",
                            "type": "product",
                            "item_id": "517",
                            "calcolo_prezzo": 1,
                            "price": "5.94",
                            "price_label": "\u20ac 5,94",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": 1,
                            "max_purchasable_pieces": 1,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Snack",
                            "category_id": "1985",
                            "subcategory_id": "1990",
                            "blueprint": {
                                "top": 22.995720864664058,
                                "left": 66.97719290905201,
                                "width": 33.02280709094799,
                                "height": 23.003652927695093
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/Scatola_Lindor_Iwhx187.png",
                                    "cropped": false,
                                    "pk": 753
                                },
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/cropped_image_Nx4UG53_MDg8sLq.png",
                                    "cropped": true,
                                    "pk": 731
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "active": true,
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "specs",
                                    "active": true,
                                    "title": "Ingredienti",
                                    "data": {
                                        "specifiche": "Zucchero, grasso vegetale, burro di cacao, pasta di cacao, latte intero in polvere, latte scremato in polvere, LATTOSIO, BURRO anidro, emulsionante, estratto di malto d\u2019ORZO, aromi. SENZA GLUTINE. (Fonte: lindt.it)",
                                        "img": [
                                            "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/images/Scatola_Lindor.png"
                                        ]
                                    }
                                }
                            ],
                            "weight_unit_of_measure": "gr",
                            "strike_price": null,
                            "discount_rate": 0,
                            "prices": null,
                            "promo": null,
                            "stock": null,
                            "tdc": null,
                            "available_from": null,
                            "related": [],
                            "brand": null,
                            "brand_logo": null,
                            "line": null,
                            "line_logo": null
                        },
                        {
                            "id": 518,
                            "ean_code": null,
                            "codice_interno_insegna": "cstm5122763179",
                            "field1": "Alberti",
                            "field2": "filetti di tonno",
                            "field3": "all'olio di oliva",
                            "field4": "200g",
                            "descrizione_estesa": "                                                    ",
                            "description": "Alberti filetti di tonno all'olio di oliva 200g",
                            "grammage": 0,
                            "offer_price": "6.90",
                            "type": "product",
                            "item_id": "518",
                            "calcolo_prezzo": 1,
                            "price": "3.93",
                            "price_label": "\u20ac 3,93",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": 1,
                            "max_purchasable_pieces": 1,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Dispensa",
                            "category_id": "1985",
                            "subcategory_id": "1986",
                            "blueprint": {
                                "top": 45.999373792359144,
                                "left": 70.99261604012533,
                                "width": 29.007383959874673,
                                "height": 22.059849942207848
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/tonno-small_7cvBe5n.jpg",
                                    "cropped": false,
                                    "pk": 754
                                },
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/cropped_image_bl2TxB3_zpFdIEr.png",
                                    "cropped": true,
                                    "pk": 732
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "active": true,
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "weight_unit_of_measure": "gr",
                            "strike_price": null,
                            "discount_rate": 0,
                            "prices": null,
                            "promo": null,
                            "stock": null,
                            "tdc": null,
                            "available_from": null,
                            "related": [],
                            "brand": null,
                            "brand_logo": null,
                            "line": null,
                            "line_logo": null
                        },
                        {
                            "id": 519,
                            "ean_code": null,
                            "codice_interno_insegna": "cstm8263754230",
                            "field1": "Tigullio",
                            "field2": "pomo e pesto",
                            "field3": "pomo e pesto olive",
                            "field4": "300g",
                            "descrizione_estesa": "                                                    ",
                            "description": "Tigullio pomo e pesto pomo e pesto olive 300g",
                            "grammage": 0,
                            "offer_price": "2.79",
                            "type": "product",
                            "item_id": "519",
                            "calcolo_prezzo": 1,
                            "price": "1.39",
                            "price_label": "\u20ac 1,39",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [
                                "pomo e pesto",
                                "pomo e pesto olive"
                            ],
                            "price_for_kg": null,
                            "available_pieces": 1,
                            "max_purchasable_pieces": 1,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Alimentari",
                            "subcategory": "Rossi",
                            "category_id": "1985",
                            "subcategory_id": "1988",
                            "blueprint": {
                                "top": 45.999373792359144,
                                "left": 36.07452716086021,
                                "width": 34.91808887926513,
                                "height": 22.059849942207848
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/Pomo_e_Pesto_WfYP0GR.png",
                                    "cropped": false,
                                    "pk": 755
                                },
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/POMO_PESTO_OLive_aBNe469.png",
                                    "cropped": false,
                                    "pk": 756
                                },
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/cropped_image_a1WvHpq_lzFBcVH.png",
                                    "cropped": true,
                                    "pk": 733
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "active": true,
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "specs",
                                    "active": true,
                                    "title": "",
                                    "data": {
                                        "specifiche": "Passata di pomodoro 64,5%, Olio di semi di girasole, Sale, Correttore di acidit\u00e0: acido lattico, Olive verdi 8,5%, Olive nere variet\u00e0 leccino 5,7%, Doppio concentrato di pomodoro 12%, Prezzemolo, Capperi, Zucchero",
                                        "img": [
                                            "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/images/Pomo_e_Pesto.png"
                                        ]
                                    }
                                }
                            ],
                            "weight_unit_of_measure": "gr",
                            "strike_price": null,
                            "discount_rate": 0,
                            "prices": null,
                            "promo": null,
                            "stock": null,
                            "tdc": null,
                            "available_from": null,
                            "related": [],
                            "brand": null,
                            "brand_logo": null,
                            "line": null,
                            "line_logo": null
                        },
                        {
                            "id": 520,
                            "ean_code": null,
                            "codice_interno_insegna": "cstm4706259359",
                            "field1": "Ceres",
                            "field2": "strong ale",
                            "field3": "0,50l",
                            "field4": "",
                            "descrizione_estesa": "                                                    ",
                            "description": "Ceres strong ale 0,50l",
                            "grammage": 0,
                            "offer_price": "1.99",
                            "type": "product",
                            "item_id": "520",
                            "calcolo_prezzo": 1,
                            "price": "0.99",
                            "price_label": "\u20ac 0,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": 1,
                            "max_purchasable_pieces": 1,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Bibite",
                            "category_id": "1982",
                            "subcategory_id": "1992",
                            "blueprint": {
                                "top": 45.999373792359144,
                                "left": 0.0,
                                "width": 36.07452716086021,
                                "height": 22.059849942207848
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/CERES_jZqKIrM.png",
                                    "cropped": false,
                                    "pk": 757
                                },
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/cropped_image_edbMXOL_lFOOgVZ.png",
                                    "cropped": true,
                                    "pk": 734
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "active": true,
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "weight_unit_of_measure": "gr",
                            "strike_price": null,
                            "discount_rate": 0,
                            "prices": null,
                            "promo": null,
                            "stock": null,
                            "tdc": null,
                            "available_from": null,
                            "related": [],
                            "brand": null,
                            "brand_logo": null,
                            "line": null,
                            "line_logo": null
                        },
                        {
                            "id": 521,
                            "ean_code": null,
                            "codice_interno_insegna": "cstm1485890072",
                            "field1": "Paololeo",
                            "field2": "negroamaro biologico igp",
                            "field3": "0,75l",
                            "field4": "Acquisto massimo giornaliero: 6 pezzi",
                            "descrizione_estesa": "                                                    ",
                            "description": "Paololeo negroamaro biologico igp 0,75l Acquisto massimo giornaliero: 6 pezzi",
                            "grammage": 0,
                            "offer_price": "11.90",
                            "type": "product",
                            "item_id": "521",
                            "calcolo_prezzo": 1,
                            "price": "2.98",
                            "price_label": "\u20ac 2,98",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": 1,
                            "max_purchasable_pieces": 1,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e spumanti",
                            "category_id": "1982",
                            "subcategory_id": "1983",
                            "blueprint": {
                                "top": 72.22019549881617,
                                "left": 0.0,
                                "width": 34.789596935043065,
                                "height": 23.876013359332077
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/CANTINA_PAOLOLEO_-_NEGROAMARO_BIOLOGICO_IGP_VSKFIHw.jpg",
                                    "cropped": false,
                                    "pk": 758
                                },
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/cropped_image_pMsgWE0_eh5wb2E.png",
                                    "cropped": true,
                                    "pk": 735
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "active": true,
                                    "title": null,
                                    "data": ""
                                }
                            ],
                            "weight_unit_of_measure": "gr",
                            "strike_price": null,
                            "discount_rate": 0,
                            "prices": null,
                            "promo": null,
                            "stock": null,
                            "tdc": null,
                            "available_from": null,
                            "related": [],
                            "brand": null,
                            "brand_logo": null,
                            "line": null,
                            "line_logo": null
                        },
                        {
                            "id": 522,
                            "ean_code": null,
                            "codice_interno_insegna": "cstm2768812770",
                            "field1": "V8+Vineyards",
                            "field2": "prosecco brut \"Berto\"",
                            "field3": "0,75l",
                            "field4": "",
                            "descrizione_estesa": "                                                    ",
                            "description": "V8+Vineyards prosecco brut \"Berto\" 0,75l",
                            "grammage": 0,
                            "offer_price": "9.90",
                            "type": "product",
                            "item_id": "522",
                            "calcolo_prezzo": 1,
                            "price": "4.95",
                            "price_label": "\u20ac 4,95",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": 1,
                            "max_purchasable_pieces": 1,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e spumanti",
                            "category_id": "1982",
                            "subcategory_id": "1983",
                            "blueprint": {
                                "top": 72.22019549881617,
                                "left": 34.789596935043065,
                                "width": 34.11499131273465,
                                "height": 23.876013359332077
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/V8_Vineyards_-_Prosecco_Vino_Spumante_CuvC387e_Brut_Berto.jpg",
                                    "cropped": false,
                                    "pk": 759
                                },
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/cropped_image_YszNW4v_ybOKnKP.png",
                                    "cropped": true,
                                    "pk": 736
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "active": true,
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "active": true,
                                    "title": "",
                                    "data": {
                                        "titolo": "Descrizione",
                                        "testo": "Vino Spumante Brut Millesimato, prodotto con uve dalle variet\u00e0 aromatiche tipiche dell\u2019alto trevigiano, con sistema di allevamento Sylvoz.",
                                        "img": [
                                            "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/images/V8_Vineyards_-_Prosecco_Vino_Spumante_CuvC387e_Brut_Berto.jpg"
                                        ]
                                    }
                                }
                            ],
                            "weight_unit_of_measure": "gr",
                            "strike_price": null,
                            "discount_rate": 0,
                            "prices": null,
                            "promo": null,
                            "stock": null,
                            "tdc": null,
                            "available_from": null,
                            "related": [],
                            "brand": null,
                            "brand_logo": null,
                            "line": null,
                            "line_logo": null
                        },
                        {
                            "id": 523,
                            "ean_code": null,
                            "codice_interno_insegna": "cstm5443212277",
                            "field1": "Geneagricola",
                            "field2": "tuleo pinot",
                            "field3": "grigio doc",
                            "field4": "0,75l",
                            "descrizione_estesa": "                                                    ",
                            "description": "Geneagricola tuleo pinot grigio doc 0,75l",
                            "grammage": 0,
                            "offer_price": "6.90",
                            "type": "product",
                            "item_id": "523",
                            "calcolo_prezzo": 1,
                            "price": "1.99",
                            "price_label": "\u20ac 1,99",
                            "equivalence": 1,
                            "quantity_step": 1,
                            "grocery_label": "pz.",
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": 1,
                            "max_purchasable_pieces": 1,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": "Bevande",
                            "subcategory": "Vini e spumanti",
                            "category_id": "1982",
                            "subcategory_id": "1983",
                            "blueprint": {
                                "top": 72.25567234247309,
                                "left": 68.90458824777772,
                                "width": 31.09541175222228,
                                "height": 23.876013359332077
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/TULEO_PINOT_GRIGIO_a8zGple.png",
                                    "cropped": false,
                                    "pk": 760
                                },
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/cropped_image_gMFoUTl_6hRaDoS.png",
                                    "cropped": true,
                                    "pk": 737
                                }
                            ],
                            "markers": [
                                {
                                    "type": "plus",
                                    "active": true,
                                    "title": null,
                                    "data": ""
                                },
                                {
                                    "type": "info",
                                    "active": true,
                                    "title": "",
                                    "data": {
                                        "titolo": "Descrizio",
                                        "testo": "Vitigno di origine francese, \u00e8 diventato il vitigno pi\u00f9 famoso al mondo proprio partendo dall\u2019 Italia: nei territori del nord-est (Veneto, Friuli e Trentino Alto Adige). Questo vitigno trova una felice collocazione e, vinificato \u201cin bianco\u201d restituisce vini di facile beva e buon corpo, che si abbinano con disinvoltura alle preparazioni pi\u00f9 diverse. Le uve, adagiate nelle presse, vengono sottoposte a spremitura soffice. La vinificazione avviene in bianco, separando immediatamente le bucce dai mosti, in vasche d\u2019 acciaio a temperatura controllata.\r\nIn seguito il vino per-mane sui lieviti per circa 3 mesi in recipienti d\u2019acciaio, per poi essere imbottigliato e riposare in bottiglia per i due mesi successivi.",
                                        "img": [
                                            "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/images/TULEO_PINOT_GRIGIO_a8zGple.png"
                                        ]
                                    }
                                }
                            ],
                            "weight_unit_of_measure": "gr",
                            "strike_price": null,
                            "discount_rate": 0,
                            "prices": null,
                            "promo": null,
                            "stock": null,
                            "tdc": null,
                            "available_from": null,
                            "related": [],
                            "brand": null,
                            "brand_logo": null,
                            "line": null,
                            "line_logo": null
                        },
                        {
                            "id": 527,
                            "ean_code": null,
                            "codice_interno_insegna": "cstm1563268854",
                            "field1": "",
                            "field2": "",
                            "field3": "",
                            "field4": "",
                            "descrizione_estesa": null,
                            "description": "",
                            "grammage": 0,
                            "offer_price": null,
                            "type": "external_link",
                            "item_id": "527",
                            "calcolo_prezzo": 1,
                            "price": "0.00",
                            "price_label": "None",
                            "equivalence": null,
                            "quantity_step": null,
                            "grocery_label": null,
                            "varieties": [],
                            "price_for_kg": null,
                            "available_pieces": 1,
                            "max_purchasable_pieces": 1,
                            "points": "",
                            "fidelity_product": false,
                            "focus": false,
                            "pam": false,
                            "three_for_two": false,
                            "one_and_one_gratis": false,
                            "underpriced_product": false,
                            "category": null,
                            "subcategory": null,
                            "category_id": null,
                            "subcategory_id": null,
                            "blueprint": {
                                "top": 9.562628101505629,
                                "left": 17.17153919880466,
                                "width": 64.71410313259165,
                                "height": 9.119703694873824
                            },
                            "images": [
                                {
                                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/products/cropped_image_ZLJOX1q_hDpwYc4.png",
                                    "cropped": true,
                                    "pk": 765
                                }
                            ],
                            "markers": [
                                {
                                    "type": "external_link",
                                    "active": true,
                                    "title": null,
                                    "data": {
                                        "link_type": "url",
                                        "link": "https://www.google.it/maps/place/Via+Gaetano+Crespi,+9,+20134+Milano+MI/@45.4796646,9.2419079,17z/data=!3m1!4b1!4m5!3m4!1s0x4786c65baaa7bb75:0xe5428e2c944cf3dc!8m2!3d45.4796609!4d9.2440966",
                                        "show_icon": true,
                                        "tooltip": "",
                                        "title": null,
                                        "color": "#000000"
                                    }
                                }
                            ],
                            "weight_unit_of_measure": null,
                            "strike_price": null,
                            "discount_rate": 0,
                            "prices": null,
                            "promo": null,
                            "stock": null,
                            "tdc": null,
                            "available_from": null,
                            "related": [],
                            "brand": null,
                            "brand_logo": null,
                            "line": null,
                            "line_logo": null
                        }
                    ]
                },
                {
                    "number": 3,
                    "image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/pages/page_3_lCkDNcV.jpg",
                    "thumb_image_file": "https://interattivo-dev.s3.amazonaws.com/OVOdoqqVrI/pages/thumb_page_3.jpg",
                    "interactivities": []
                }
            ]
        }
    }
}

const lefletSwitch = () => {
    return leaflets.client;
}

export const serverResponse = lefletSwitch();